// Round to 2 decimals: raw fractional DPRs (e.g. 2.2) serialize to long floats
// like "2.200000047683716", which the backend @Size(max) on `dp` rejects (HTTP 400).
export function roundDevicePixelRatio(dpr: number): string {
  return String(Math.round(dpr * 100) / 100);
}
